import React from "react";
import PropTypes from "prop-types";

export default function PatientNotesItem(props) {
    return (
        <div
            id="patient-notes-tab-item"
            className="pendo-ignore w-full flex-col border-b border-b-neutral-100 px-6 py-2.5"
        >
            <div className="flex justify-between">
                <div className="mb-1">
                    <div>{props.doctorName}</div>
                    <div>{props.doctorEmail}</div>
                </div>
                {props.date}
            </div>
            <div className="w-full wrap-break-word whitespace-pre-wrap">
                &quot;{props.note}&quot;
            </div>
        </div>
    );
}

PatientNotesItem.propTypes = {
    doctorName: PropTypes.string,
    doctorEmail: PropTypes.string,
    date: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
};
